import { render, staticRenderFns } from "./baseSelectTable.vue?vue&type=template&id=48fa41e8&scoped=true"
import script from "./baseSelectTable.vue?vue&type=script&lang=js"
export * from "./baseSelectTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa41e8",
  null
  
)

export default component.exports